import "./__styles__/Icon.scss";
import { SVGProps } from "react";

const CaretDownBold = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.95312L5 6.09375L9 1.95312"
        stroke="#0C111B"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CaretDownBold;
